import React from 'react';

const Footer = () => {
    return (
        <footer className='footer'>
            <h4>FateGrid - The daily FGO trivia Game</h4>
            <a href="mailto:fategrid@outlook.com">Contact</a>
            <div style={{paddingLeft: "25vw", paddingRight: "25vw"}}>
            <p>Disclaimer: FateGrid is not affiliated with, endorsed, or approved by Fate/Grand Order or its creators.</p>
            <p>Used game data and images from <a href="https://apps.atlasacademy.io/db/">Atlas Academy DB</a>.</p>
            </div>
        </footer>
    );
};

export default Footer;
        